export default __webpack_public_path__ + "static/media/icon_pm2.5.e58c066e.svg";